import { render, staticRenderFns } from "./listInvestorParticulars.vue?vue&type=template&id=58af14ba&scoped=true"
import script from "./listInvestorParticulars.vue?vue&type=script&lang=js"
export * from "./listInvestorParticulars.vue?vue&type=script&lang=js"
import style0 from "./listInvestorParticulars.vue?vue&type=style&index=0&id=58af14ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58af14ba",
  null
  
)

export default component.exports